import React, { useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  Typography,
  Card,
  CardContent,
  Button,
  Box,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Chip,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { TRAVEL_TARIFF } from "./tariffData";

// ===============================
// Country Data & Schengen List
// ===============================
const COUNTRIES = [
  // --- Special Selection ---
  { label: "Schengen Countries (All)", isSchengen: true },

  // --- Schengen Area Countries ---
  { label: "Austria", isSchengen: true },
  { label: "Belgium", isSchengen: true },
  { label: "Bulgaria", isSchengen: true },
  { label: "Croatia", isSchengen: true },
  { label: "Czech Republic", isSchengen: true },
  { label: "Denmark", isSchengen: true },
  { label: "Estonia", isSchengen: true },
  { label: "Finland", isSchengen: true },
  { label: "France", isSchengen: true },
  { label: "Germany", isSchengen: true },
  { label: "Greece", isSchengen: true },
  { label: "Hungary", isSchengen: true },
  { label: "Iceland", isSchengen: true },
  { label: "Italy", isSchengen: true },
  { label: "Latvia", isSchengen: true },
  { label: "Liechtenstein", isSchengen: true },
  { label: "Lithuania", isSchengen: true },
  { label: "Luxembourg", isSchengen: true },
  { label: "Malta", isSchengen: true },
  { label: "Netherlands", isSchengen: true },
  { label: "Norway", isSchengen: true },
  { label: "Poland", isSchengen: true },
  { label: "Portugal", isSchengen: true },
  { label: "Romania", isSchengen: true },
  { label: "Slovakia", isSchengen: true },
  { label: "Slovenia", isSchengen: true },
  { label: "Spain", isSchengen: true },
  { label: "Sweden", isSchengen: true },
  { label: "Switzerland", isSchengen: true },

  // --- Non-Schengen (Common Destinations) ---
  { label: "Afghanistan", isSchengen: false },
  { label: "Albania", isSchengen: false },
  { label: "Algeria", isSchengen: false },
  { label: "Andorra", isSchengen: false },
  { label: "Angola", isSchengen: false },
  { label: "Argentina", isSchengen: false },
  { label: "Armenia", isSchengen: false },
  { label: "Australia", isSchengen: false },
  { label: "Azerbaijan", isSchengen: false },
  { label: "Bahamas", isSchengen: false },
  { label: "Bahrain", isSchengen: false },
  { label: "Bangladesh", isSchengen: false },
  { label: "Barbados", isSchengen: false },
  { label: "Bhutan", isSchengen: false },
  { label: "Bolivia", isSchengen: false },
  { label: "Bosnia and Herzegovina", isSchengen: false },
  { label: "Botswana", isSchengen: false },
  { label: "Brazil", isSchengen: false },
  { label: "Brunei", isSchengen: false },
  { label: "Cambodia", isSchengen: false },
  { label: "Canada", isSchengen: false },
  { label: "Chile", isSchengen: false },
  { label: "China", isSchengen: false },
  { label: "Colombia", isSchengen: false },
  { label: "Costa Rica", isSchengen: false },
  { label: "Cuba", isSchengen: false },
  { label: "Cyprus", isSchengen: false },
  { label: "Dominican Republic", isSchengen: false },
  { label: "Ecuador", isSchengen: false },
  { label: "Egypt", isSchengen: false },
  { label: "Ethiopia", isSchengen: false },
  { label: "Fiji", isSchengen: false },
  { label: "Georgia", isSchengen: false },
  { label: "Ghana", isSchengen: false },
  { label: "Hong Kong", isSchengen: false },
  { label: "India", isSchengen: false },
  { label: "Indonesia", isSchengen: false },
  { label: "Iran", isSchengen: false },
  { label: "Iraq", isSchengen: false },
  { label: "Ireland", isSchengen: false },
  { label: "Jamaica", isSchengen: false },
  { label: "Japan", isSchengen: false },
  { label: "Jordan", isSchengen: false },
  { label: "Kazakhstan", isSchengen: false },
  { label: "Kenya", isSchengen: false },
  { label: "Kuwait", isSchengen: false },
  { label: "Lebanon", isSchengen: false },
  { label: "Libya", isSchengen: false },
  { label: "Malaysia", isSchengen: false },
  { label: "Maldives", isSchengen: false },
  { label: "Mauritius", isSchengen: false },
  { label: "Mexico", isSchengen: false },
  { label: "Monaco", isSchengen: false },
  { label: "Mongolia", isSchengen: false },
  { label: "Montenegro", isSchengen: false },
  { label: "Morocco", isSchengen: false },
  { label: "Myanmar", isSchengen: false },
  { label: "Namibia", isSchengen: false },
  { label: "Nepal", isSchengen: false },
  { label: "New Zealand", isSchengen: false },
  { label: "Nigeria", isSchengen: false },
  { label: "Oman", isSchengen: false },
  { label: "Pakistan", isSchengen: false },
  { label: "Palestine", isSchengen: false },
  { label: "Panama", isSchengen: false },
  { label: "Peru", isSchengen: false },
  { label: "Philippines", isSchengen: false },
  { label: "Qatar", isSchengen: false },
  { label: "Russia", isSchengen: false },
  { label: "Saudi Arabia", isSchengen: false },
  { label: "Serbia", isSchengen: false },
  { label: "Seychelles", isSchengen: false },
  { label: "Singapore", isSchengen: false },
  { label: "South Africa", isSchengen: false },
  { label: "South Korea", isSchengen: false },
  { label: "Sri Lanka", isSchengen: false },
  { label: "Taiwan", isSchengen: false },
  { label: "Tanzania", isSchengen: false },
  { label: "Thailand", isSchengen: false },
  { label: "Tunisia", isSchengen: false },
  { label: "Turkey", isSchengen: false },
  { label: "Uganda", isSchengen: false },
  { label: "Ukraine", isSchengen: false },
  { label: "United Arab Emirates", isSchengen: false },
  { label: "United Kingdom", isSchengen: false },
  { label: "United States (USA)", isSchengen: false },
  { label: "Uruguay", isSchengen: false },
  { label: "Uzbekistan", isSchengen: false },
  { label: "Vietnam", isSchengen: false },
  { label: "Zambia", isSchengen: false },
  { label: "Zimbabwe", isSchengen: false },
];

const FLAT_RATES = {
  "Plan A": {
    "Worldwide Excluding USA & Canada": { "18-40": 2093, "41-59": 3161 },
    "Worldwide Including USA & Canada": { "18-40": 3370, "41-59": 6375 },
  },
  "Plan B": {
    "Worldwide Excluding USA & Canada": { "18-40": 1675, "41-59": 2529 },
    "Worldwide Including USA & Canada": { "18-40": 2696, "41-59": 5100 },
  },
};

const HealthForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    category: "INDIVIDUAL",
    plan: "Plan B",
    region: "Worldwide Excluding USA & Canada",
    visitingCountries: [], // NEW FIELD
    birthdate: "1986-02-05",
    passportName: "",
    passportNumber: "",
    passportFile: null,
    age: 0,
    ageBand: "",
    travelDays: "",
    price: 0,
    travelDate: "",
  });

  const [openDetails, setOpenDetails] = useState(false);

  // === Helpers ===
  const getAge = (birthdate) => {
    if (!birthdate) return 0;
    const dob = new Date(birthdate);
    const diff = Date.now() - dob.getTime();
    const ageDate = new Date(diff);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };

  const getAgeBand = (age) => {
    if (age < 0.5) return "0.5-40";
    if (age <= 40) return "0.5-40";
    if (age <= 50) return "41-50";
    if (age <= 65) return "51-65";
    if (age <= 70) return "66-70";
    if (age <= 75) return "71-75";
    if (age <= 79) return "76-79";
    return null;
  };

  const getTariffPremium = (plan, region, ageBand, days) => {
    try {
      const planData = TRAVEL_TARIFF?.[plan]?.regions?.[region]?.[ageBand];
      if (!planData) return 0;
      const match =
        planData.find((t) => days <= t.days) || planData[planData.length - 1];
      return match?.premium || 0;
    } catch {
      return 0;
    }
  };

  const getFlatPremium = (plan, region, age, days) => {
    if (age > 59) {
      alert("❌ Sorry, coverage is not available for age above 59.");
      return 0;
    }
    const range = age <= 40 ? "18-40" : "41-59";
    const baseMonthly = Number(FLAT_RATES?.[plan]?.[region]?.[range]);
    if (!baseMonthly) return 0;

    const dayCount = days;
    if (isNaN(dayCount) || dayCount <= 0) return 0;

    const cappedDays = Math.min(dayCount, 180);
    const months = Math.ceil(cappedDays / 30);
    return baseMonthly * months;
  };

  const calculatePremium = (data) => {
    const { category, plan, region, birthdate, travelDays } = data;
    const age = getAge(birthdate);
    const ageBand = getAgeBand(age);
    const days = parseInt(travelDays) || 0;

    if (!age || !days) {
      return { base: 0, subtotal: 0, vat: 0, total: 0, age, ageBand };
    }

    let base = 0;
    if (category === "INDIVIDUAL") {
      base = getTariffPremium(plan, region, ageBand, days);
    } else {
      base = getFlatPremium(plan, region, age, days);
    }

    const subtotal = base;
    const vat = subtotal * 0.15;
    const total = Math.round(subtotal + vat);

    return { base, subtotal, vat, total, age, ageBand, price: total };
  };
const handlePassportUpload = async (file) => {
  const uploadData = new FormData();
  uploadData.append("passportFile", file);

  try {
    const response = await fetch("https://www.bgicdigital.com/admin/scan_passport.php", {
      method: "POST",
      body: uploadData, // This sends the binary file correctly
    });

    const result = await response.json();



    if (result.success) {
      const extractedData = result.data;

     // alert(JSON.stringify(result.data));
      
      // Use a functional update to ensure we have the absolute latest state
      setFormData((prev) => {
        const updated = {
          ...prev,
          passportName: extractedData.passport_name || prev.passportName,
          passportNumber: extractedData.passport_number || prev.passportNumber,
          birthdate: extractedData.birthdate || prev.birthdate,
        };

        // Recalculate Age and Premium using the new data
        const age = getAge(updated.birthdate);
        updated.age = age;
        updated.ageBand = getAgeBand(age);
        
        const calc = calculatePremium(updated);
        return { ...updated, ...calc };
      });
      
      //alert("✅ Passport details extracted successfully!");
    } else {
        console.error("OCR Error:", result.message);
        alert("OCR Error:", result.message);
    }
  } catch (error) {

    //alert(error);
    alert("OCR Scanning failed: ",error);
  }
};


  // === Change Handler ===
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "passportFile") {
    const file = files[0];
    if (!file) return;

    // ১. ফাইল টাইপ ভ্যালিডেশন (শুধুমাত্র ছবি এলাউ করা হয়েছে)
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      alert("❌ Please Upload JPG or PNG ");
      
      // ইনপুট ফিল্ড ক্লিয়ার করে দেওয়া
      e.target.value = null; 
      return;
    }

    // ২. স্টেট সেট করা
    setFormData((prev) => ({ ...prev, passportFile: file }));

    // ৩. OCR স্ক্যান শুরু করা
    handlePassportUpload(file);
    return;
  }



    let updated = { ...formData, [name]: value };

    if (name === "travelDays") {
      const days = parseInt(value) || 0;
      if (days > 180) {
        alert("Maximum coverage is 180 days only.");
        updated.travelDays = 180;
      }
    }

    if (name === "birthdate") {
      const age = getAge(value);
      updated.age = age;
      updated.ageBand = getAgeBand(age);
    }

    const calc = calculatePremium(updated);
    setFormData({ ...updated, ...calc });
  };

  // === NEW: Country Selection Handler ===
  const handleCountryChange = (event, newValue) => {
    const hasSchengen = newValue.some((country) => country.isSchengen);
    
    let updated = { 
      ...formData, 
      visitingCountries: newValue,
      // Rule: If Schengen is selected, force Region to Excluding USA/Canada
      region: hasSchengen ? "Worldwide Excluding USA & Canada" : formData.region 
    };

    const calc = calculatePremium(updated);
    setFormData({ ...updated, ...calc });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.visitingCountries.length === 0) {
      alert("Please select at least one visiting country.");
      return;
    }
    if (!formData.passportFile) {
      alert("Please upload your passport copy before proceeding.");
      return;
    }
    const calc = calculatePremium(formData);
    onSubmit({
      productType: "Travel Health Insurance",
      data: { ...formData, ...calc },
    });
  };

  const { base = 0, vat = 0, total = 0, age, ageBand } = calculatePremium(formData);

  return (
    <form onSubmit={handleSubmit}>

<Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3,
    flexWrap: "wrap",
    gap: 2,
  }}
>
  <Box>
    <Typography variant="h5" sx={{ fontWeight: 600 }}>
      Overseas Mediclaim Policy (OMP)/
      <br/> Travel Insurance
    </Typography>

    <Typography
      variant="body2"
      sx={{ color: "text.secondary" }}
    >
      Please complete the form below to proceed.
    </Typography>
  </Box>

  <Button
    variant="outlined"
    color="secondary"
    onClick={() => setOpenDetails(true)}
    sx={{
      textTransform: "none",
      borderRadius: 2,
      px: 3,
      fontWeight: 500,
    }}
  >
    View Details
  </Button>
</Box>

      <Grid container spacing={3}>
        {/* Category */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Traveller Category</Typography>
          <FormControl fullWidth>
            <Select name="category" value={formData.category} onChange={handleChange}>
              <MenuItem value="INDIVIDUAL">Individual</MenuItem>
              <MenuItem value="STUDENT">Student</MenuItem>
              <MenuItem value="ACCOMPANYING_SPOUSE">Accompanying Spouse</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* NEW: Visiting Countries (Searchable Multi-select) */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Visiting Countries</Typography>
          <Autocomplete
            multiple
            options={COUNTRIES}
            getOptionLabel={(option) => option.label}
            value={formData.visitingCountries}
            onChange={handleCountryChange}
            filterSelectedOptions
            renderTags={(tagValue, getTagProps) =>
              tagValue.map((option, index) => (
                <Chip label={option.label} {...getTagProps({ index })} size="small" />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} placeholder="Search Countries..." />
            )}
          />
        </Grid>

        {/* Region */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Travel Region</Typography>
          <FormControl fullWidth>
            <Select
              name="region"
              value={formData.region}
              onChange={handleChange}
              // Disable manual selection if a Schengen country is selected to prevent logic errors
              disabled={formData.visitingCountries.some(c => c.isSchengen)}
            >
              <MenuItem value="Worldwide Excluding USA & Canada">Worldwide Excluding USA & Canada</MenuItem>
              <MenuItem value="Worldwide Including USA & Canada">Worldwide Including USA & Canada</MenuItem>
            </Select>
          </FormControl>
          {formData.visitingCountries.some(c => c.isSchengen) && (
             <Typography variant="caption" color="primary">Region locked to 'Excluding USA & Canada' for Schengen travel.</Typography>
          )}
        </Grid>

        {/* Plan */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Select Plan</Typography>
          <FormControl fullWidth>
            <Select name="plan" value={formData.plan} onChange={handleChange}>
              <MenuItem value="Plan A">Plan A (USD 100,000)</MenuItem>
              <MenuItem value="Plan B">Plan B (USD 50,000)</MenuItem>
            </Select>
          </FormControl>
        </Grid>


           {/* File Upload */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Upload Passport Copy</Typography>
          <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />} fullWidth sx={{ height: '56px', textTransform: 'none' }}>
            {formData.passportFile ? formData.passportFile.name : "Choose File (JPG, PNG)"}
            <input type="file" name="passportFile" hidden accept=" .jpg, .jpeg, .png" onChange={handleChange} />
          </Button>
        </Grid>

        {/* Date of Birth */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Date of Birth</Typography>
          <TextField type="date" name="birthdate" value={formData.birthdate} onChange={handleChange} fullWidth required />
          {age > 0 && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Age: <strong>{age}</strong> yrs — Band: <strong>{ageBand || "N/A"}</strong>
            </Typography>
          )}
        </Grid>

        {/* Travel Days */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Number of Travel Days</Typography>
          <TextField type="number" name="travelDays" value={formData.travelDays} onChange={handleChange} fullWidth required />
        </Grid>

        {/* Passport Name */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Name (as per Passport)</Typography>
          <TextField name="passportName" value={formData.passportName} onChange={handleChange} fullWidth required />
        </Grid>

        {/* Passport Number */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Passport Number</Typography>
          <TextField name="passportNumber" value={formData.passportNumber} onChange={handleChange} fullWidth required />
        </Grid>

        {/* Travel Date */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Date of Travel</Typography>
          <TextField type="date" name="travelDate" value={formData.travelDate} onChange={handleChange} fullWidth required />
        </Grid>

     

        {/* Premium Table */}
        <Grid item xs={12}>
          <Card variant="outlined" sx={{ p: 2 }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>Premium Computation</Typography>
              <Box component="table" sx={{ width: "100%", borderCollapse: "collapse" }}>
                <Box component="tbody">
                  <Box component="tr">
                    <Box component="td" sx={{ border: "1px solid #ccc", p: 1 }}>Base Premium</Box>
                    <Box component="td" sx={{ border: "1px solid #ccc", p: 1, textAlign: "right" }}>৳ {base.toFixed(2)}</Box>
                  </Box>
                  <Box component="tr">
                    <Box component="td" sx={{ border: "1px solid #ccc", p: 1 }}>VAT (15%)</Box>
                    <Box component="td" sx={{ border: "1px solid #ccc", p: 1, textAlign: "right" }}>৳ {vat.toFixed(2)}</Box>
                  </Box>
                  <Box component="tr" sx={{ backgroundColor: "#e8f4ff" }}>
                    <Box component="td" sx={{ border: "1px solid #ccc", p: 1, fontWeight: 700 }}>Total Payable</Box>
                    <Box component="td" sx={{ border: "1px solid #ccc", p: 1, textAlign: "right", fontWeight: 700 }}>৳ {total.toFixed(2)}</Box>
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Button type="submit" variant="contained" color="primary" sx={{ width: "100%", py: 1.5, fontWeight: 600, fontSize: 16, mt: 2 }}>
        Add to Cart
      </Button>

      <Box
            sx={{
              mt: 3,
              p: 2.5,
              borderRadius: 2,
              backgroundColor: "#eef7ff",
              border: "1px solid #c9e2ff",
            }}
          >
          <Typography variant="body2" sx={{ lineHeight: 1.8 }}>
            <strong>💙 Visa Rejection Protection</strong><br />
            While most insurers do not offer refunds once a travel policy is issued,
            <strong> BGIC believes in supporting our customers.</strong>
            In the event your visa application is officially rejected, you may apply
            for a premium refund upon submission of the rejection letter.
            <br /><br />
            Please note that 80% of the premium amount will be refunded if the refund request 
            is submitted within 7 days from the date of visa refusal, in accordance with the 
            policy terms and conditions.
            <br /><br />
            We understand that international travel plans can sometimes be uncertain —
            and at BGIC, your peace of mind comes first.
          </Typography>
      </Box>

      {/* Details Dialog */}
      <Dialog open={openDetails} onClose={() => setOpenDetails(false)} maxWidth="md" fullWidth>
        <DialogTitle>Overseas Mediclaim Insurance(OMP)/Travel Insurance</DialogTitle>
        <DialogContent dividers sx={{ lineHeight: 1.7 }}>
                  <Typography variant="h6" gutterBottom><strong>Medical Expenses Cover</strong></Typography>
                  <Typography variant="body2" gutterBottom>
                    <strong>Claim well be settled in Euro for Schengen country equivalent to USD</strong> 
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    If treatment continuation in Bangladesh is recommended by the appointed TPA/Claims Handler, expenses 
                    may be covered for up to <strong>90 days</strong> after returning.
                  </Typography>
        
                  <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}><strong>Covered Expenses Include:</strong></Typography>
                  <ul>
                    <li>Physician, hospital, and medical service expenses</li>
                    <li>Dental care for immediate pain relief up to $500.</li>
                    <li>Emergency medical evacuation and transportation.</li>
                    <li>Repatriation of remains to Bangladesh.</li>
                  </ul>
        
                  <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}><strong>Exclusions:</strong></Typography>
                  <ul>
                    <li>Pre-existing medical conditions</li>
                    <li>Traveling against medical advice</li>
                    <li>Expenses below deductible</li>
                    <li>Self-inflicted injury, drug/alcohol abuse</li>
                    <li>Pregnancy and related complications</li>
                    <li>Insured intending to travel more than 92 consecutive days</li>
                    <li>Persons of less than 30 days old</li>
                    <li>Trips initiated before policy issue </li>
                    <li>Travelling for work reasons </li>
                    <li>Women after 32nd week of Pregnancy</li>
        
                  </ul>
        
                  <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}><strong>Conditions:</strong></Typography>
                  <ul>
                    <li>Insured must be Bangladeshi citizens aged between 1 months and 75 years</li>
                    <li>Not having Angina or chest pain at rest</li>
                    <li>Not having any infectious disease</li>
                    <li>Insured not having record of recent heart attack and stroke (1-8 weeks)</li>
                    <li>Insured not having record of recent surgery where trapped air or gas may be present</li>
                    <li>Not having severe chronic respiratory disease</li>
                    <li>Not having pneumothorax, sickle cell anemia, psychotic illnes</li>
        
                  </ul>
                </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDetails(false)} color="primary" variant="contained">Got It</Button>
        </DialogActions>
      </Dialog>
    </form>
  );
};

export default HealthForm;